import { getFileExtension } from "./getFileExtension";

export const getGcsFilename = (args: { fileId: string; filename?: string }): string => {
  // if no filename, return fileId without any extension
  if (!args.filename) return args.fileId;
  const fileExtension = getFileExtension(args.filename);
  return `${args.fileId}.${fileExtension}`;
};
